import { Link, useLocation } from 'react-router-dom';
import type { ComponentProps, ReactNode } from 'react';

/**
 * A ``<Link>`` that preserves the current URL search string (so query
 * params like ``?lang=ta`` survive navigation). React Router doesn't
 * carry them across ``<Link>`` transitions by default.
 */
export default function KeepLink({
    to,
    children,
    ...rest
}: Omit<ComponentProps<typeof Link>, 'to'> & {
    to: string;
    children: ReactNode;
}) {
    const { search } = useLocation();
    return (
        <Link to={`${to}${search}`} {...rest}>
            {children}
        </Link>
    );
}
